import { LayoutGrid, Lightbulb, LogOut, Settings, ShoppingBag, Tags } from 'lucide-react';
import { NavLink, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { adminApi, isLoggedIn } from '../../lib/admin';

/** Guard: bez tokenu přesměruje na přihlášení. */
export function RequireAdmin({ children }: { children: React.ReactNode }) {
  if (!isLoggedIn()) {
    return <Navigate to="/admin/prihlaseni" replace />;
  }
  return <>{children}</>;
}

function TabLink({ to, label, icon: Icon }: { to: string; label: string; icon: typeof ShoppingBag }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `inline-flex h-10 items-center gap-2 rounded-xl px-3.5 text-sm font-semibold transition ${
          isActive
            ? 'bg-chalk text-board'
            : 'text-chalk/80 hover:bg-white/10 hover:text-chalk'
        }`
      }
    >
      <Icon className="h-4 w-4" strokeWidth={2} />
      {label}
    </NavLink>
  );
}

export default function AdminShell() {
  const navigate = useNavigate();

  const logout = async () => {
    await adminApi.logout();
    toast.success('Odhlášeno');
    navigate('/admin/prihlaseni', { replace: true });
  };

  return (
    <div className="flex min-h-screen flex-col bg-paper">
      <header className="board text-chalk">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-3">
          <div className="flex items-center gap-2.5">
            <span className="grid h-9 w-9 place-items-center rounded-[11px] bg-white/10">
              <Lightbulb className="h-5 w-5 text-accent" strokeWidth={2} />
            </span>
            <span className="font-serif text-xl tracking-tight">Správa</span>
          </div>
          <nav className="flex items-center gap-1.5" aria-label="Sekce správy">
            <TabLink to="/admin/objednavky" label="Objednávky" icon={ShoppingBag} />
            <TabLink to="/admin/produkty" label="Materiály" icon={LayoutGrid} />
            <TabLink to="/admin/kategorie" label="Kategorie" icon={Tags} />
            <TabLink to="/admin/nastaveni" label="Nastavení" icon={Settings} />
            <button
              type="button"
              onClick={logout}
              className="ml-1 inline-flex h-10 items-center gap-2 rounded-xl px-3 text-sm font-semibold text-chalk/80 transition hover:bg-white/10 hover:text-chalk"
            >
              <LogOut className="h-4 w-4" strokeWidth={2} />
              Odhlásit
            </button>
          </nav>
        </div>
      </header>

      <main className="grid-paper flex-1">
        <Outlet />
      </main>
    </div>
  );
}
